import { render, staticRenderFns } from "./sellDemandContent.vue?vue&type=template&id=20bbf21a&scoped=true"
import script from "./sellDemandContent.vue?vue&type=script&lang=js"
export * from "./sellDemandContent.vue?vue&type=script&lang=js"
import style0 from "./sellDemandContent.vue?vue&type=style&index=0&id=20bbf21a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bbf21a",
  null
  
)

export default component.exports